<script>
  import { fade } from "svelte/transition";
  import { onMount, afterUpdate, onDestroy } from "svelte";
  import { get } from "svelte/store";
  import { activeTask } from "../../../stores/tasks.js";
  import flash from "../../../stores/flash.js";
  import { getLocal, persist } from "../../../stores/store";

  let updates;
  let custom = "";

  afterUpdate(() => {
    flash(updates);
  });

  export let name;
  localStorage.setItem("taskName", JSON.stringify(name));

  const minutesToSeconds = minutes => minutes * 60;
  const secondsToMinutes = seconds => Math.floor(seconds / 60);
  const padWithZeroes = number => number.toString().padStart(2, "0");
  const State = { idle: "idle", inProgress: "in progress", resting: "resting" };

  const WORK = minutesToSeconds(25);
  const LONG_WORK = minutesToSeconds(45);
  const LONG_BREAK_S = minutesToSeconds(20);
  const SHORT_BREAK_S = minutesToSeconds(5);

  let currentState = State.idle;
  let pomodoroTime = WORK;
  let completedPomodoros = 0;
  let interval;
  let isPaused = false;
  let finishTime = 0;

  $: maxTime = 1500;

  const setPomodoro = time => {
    if (time === "work") {
      pomodoroTime = WORK;
      maxTime = 1500;
      localStorage.setItem("maxTime", JSON.stringify(maxTime));
    } else if (time === "long") {
      pomodoroTime = LONG_WORK;
      maxTime = 2700;
      localStorage.setItem("maxTime", JSON.stringify(maxTime));
    } else if (time === "break") {
      pomodoroTime = SHORT_BREAK_S;
      maxTime = 300;
      localStorage.setItem("maxTime", JSON.stringify(maxTime));
    } else if (time === "long_break") {
      maxTime = 900;
      localStorage.setItem("maxTime", JSON.stringify(maxTime));
    } else if (time === custom) {
      maxTime = minutesToSeconds(custom);
      pomodoroTime = maxTime;
      localStorage.setItem("maxTime", JSON.stringify(maxTime));
    }
    console.log("set");
  };

  function formatTime(timeInSeconds) {
    const minutes = secondsToMinutes(timeInSeconds);
    const remainingSeconds = timeInSeconds % 60;
    return `${padWithZeroes(minutes)}:${padWithZeroes(remainingSeconds)}`;
  }

  function startPomodoro() {
    finishTime = new Date().getTime() + pomodoroTime;
    localStorage.setItem("finishTime", JSON.stringify(finishTime));
    let now = Date.now().getTime;
    if (now > finishTime) return;
    else if (now < finishTime) {
      pomodoroTime = now - finishTime;
      setState(State.inProgress);
      interval = setInterval(() => {
        localStorage.setItem("pomodoro", JSON.stringify(pomodoroTime));
        if (pomodoroTime === 0) {
          completePomodoro();
          localStorage.setItem("pomodoro", JSON.stringify(0));
          localStorage.setItem("finishTime", JSON.stringify(0));
        }
        pomodoroTime -= 1;
      }, 1000);
    } else {
      setState(State.inProgress);
      interval = setInterval(() => {
        localStorage.setItem("pomodoro", JSON.stringify(pomodoroTime));
        if (pomodoroTime === 0) {
          completePomodoro();
          localStorage.setItem("pomodoro", JSON.stringify(0));
          localStorage.setItem("finishTime", JSON.stringify(0));
        }
        pomodoroTime -= 1;
      }, 1000);
    }
  }

  const handlePause = () => {
    let tempTime = pomodoroTime;
    isPaused = !isPaused;
    if (isPaused) {
      setState(State.idle);
      clearInterval(interval);
    } else {
      setState(State.inProgress);
      interval = setInterval(() => {
        if (pomodoroTime === 0) {
          completePomodoro();
        }
        pomodoroTime -= 1;
      }, 1000);
    }
  };

  function setState(newState) {
    clearInterval(interval);
    currentState = newState;
  }

  function completePomodoro() {
    $activeTask.actualPomodoros++;
    completedPomodoros++;
    if (completedPomodoros === 4) {
      rest(LONG_BREAK_S);
      completedPomodoros = 0;
    } else {
      rest(SHORT_BREAK_S);
      name = "Break";
    }
  }

  function rest(time) {
    setState(State.resting);
    pomodoroTime = time;
    interval = setInterval(() => {
      if (pomodoroTime === 0) {
        idle();
      }
      pomodoroTime -= 1;
    }, 1000);
  }

  function cancelPomodoro() {
    let check = confirm("Are you sure you want to cancel your timer?");
    if (!check) {
      return;
    } else idle();
  }

  function idle() {
    setState(State.idle);
    pomodoroTime = pomodoroTime;
  }

  onMount(() => {
    pomodoroTime = getLocal("pomodoro") || WORK;
  });

  onDestroy(() => {
    clearInterval(interval);
  });
</script>

<style>
  .pomWrap {
    display: grid;
    grid-gap: 1vh;
    position: relative;
  }

  progress {
    cursor: pointer;
    margin-top: 15px;
    display: block;
    width: 100%;
    height: 25px;
    border-radius: 5px;
    transform: scaleX(-1);
    -webkit-appearance: none;
    -moz-appearance: none;
    background: linear-gradient(
      to right,
      rgb(10, 207, 233) 0%,
      rgb(26, 130, 144) 100%
    );
  }

  progress[value]::-moz-progress-bar {
    background-image: -moz-linear-gradient(
        45deg,
        transparent 33%,
        rgba(0, 0, 0, 0.1) 33%,
        rgba(0, 0, 0, 0.1) 66%,
        transparent 66%
      ),
      -moz-linear-gradient(top, rgba(255, 255, 255, 0.7), transparent, rgba(255, 255, 255, 0.7)),
      -moz-linear-gradient(left, rgb(28, 168, 187), rgb(2, 226, 255));

    border-radius: 5px;
    background-size: 35px 25px, 100% 100%, 100% 100%;
  }

  progress[value]::-webkit-progress-bar {
    background-color: #eee;
    border-radius: 5px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) inset;
  }

  progress[value]::-webkit-progress-value {
    background-image: -webkit-linear-gradient(
        45deg,
        transparent 33%,
        rgba(0, 0, 0, 0.1) 33%,
        rgba(0, 0, 0, 0.1) 66%,
        transparent 66%
      ),
      -webkit-linear-gradient(top, rgba(255, 255, 255, 0.7), transparent, rgba(255, 255, 255, 0.7)),
      -webkit-linear-gradient(left, rgb(28, 168, 187), rgb(2, 226, 255));

    border-radius: 5px;
    background-size: 35px 25px, 100% 100%, 100% 100%;
  }

  p,
  time {
    color: rgb(73, 77, 78);
  }

  time {
    font-weight: bold;
    margin-left: 10px;
    font-size: 2vh;
    justify-self: flex-end;
  }

  .name {
    font-weight: bold;
    margin-right: 10px;
  }

  .barFooter {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1vh;
  }

  .timerWrap {
    position: absolute;
    top: -52px;
    display: grid;
    justify-self: flex-end;
  }

  .timer {
    cursor: pointer;
    width: 47px;
    height: 47px;
    transition: all 0.2s ease-in;
    border: none;
  }

  .timer:hover {
    animation: shake 100ms linear infinite;
    border: none;
    filter: sepia(1) hue-rotate(150deg) saturate(1.5) brightness(1);
  }

  @keyframes shake {
    0% {
      transform: translate(2px, 0);
    }
    50% {
      transform: translate(-2px, 0);
    }
    100% {
      transform: translate(2px, 0);
    }
  }

  .start {
    font-size: 1.5vh;
    text-align: center;
    margin-top: -10px;
  }

  footer {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }

  footer > input {
    width: 50px;
    position: relative;
    top: 4px;
  }

  button {
    border: 1px inset rgba(255, 255, 255, 0.25);
    box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.25) inset;
    padding: 5px 10px;
    margin: 0 5px;
    background-color: rgb(33, 157, 168);
    cursor: pointer;
    background: linear-gradient(
        top,
        rgba(255, 255, 255, 0.7),
        transparent,
        rgba(255, 255, 255, 0.7)
      ),
      linear-gradient(left, rgb(28, 168, 187), rgb(2, 226, 255));
    background: -webkit-linear-gradient(
        top,
        rgba(255, 255, 255, 0.7),
        transparent,
        rgba(255, 255, 255, 0.7)
      ),
      -webkit-linear-gradient(left, rgb(28, 168, 187), rgb(2, 226, 255));
    border-radius: 5px;
    text-decoration: none;

    transition: all 0.1s linear;
    position: relative;
  }

  button:hover {
    background: linear-gradient(
      top,
      rgba(255, 255, 255, 0.5),
      rgba(255, 255, 255),
      rgba(255, 255, 255, 0.5)
    );
    background: -webkit-linear-gradient(
      top,
      rgba(255, 255, 255, 0.5),
      rgba(255, 255, 255),
      rgba(255, 255, 255, 0.5)
    );
    color: rgb(73, 77, 78);
    filter: sepia(1) hue-rotate(130deg) saturate(1);
  }

  button:active,
  span:active {
    top: 1px;
  }

  .gradient-text {
    transition: all 0.1s linear;
    position: relative;
    color: #fff;
    font-size: 2vh;
    font-weight: 600;
    text-shadow: -2px 2px 2px rgb(73, 77, 78, 0.2),
      -5px 5px 5px rgb(73, 77, 78, 0.3);
  }

  button:hover > span {
    background: linear-gradient(
      top,
      #1098b7,
      #0bbdde,
      #1098b7,
      #0bbdde,
      #1098b7
    );
    background: -webkit-linear-gradient(
      top,
      #1098b7,
      #0bbdde,
      #1098b7,
      #0bbdde,
      #1098b7
    );
    text-shadow: 1px 2px 3px rgba(238, 238, 238, 0.774),
      0 0 0 rgba(73, 77, 78, 0.2), 1px 2px 3px rgb(73, 77, 78);
    color: rgb(73, 77, 78);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
  }
</style>

<section transition:fade={{ duration: 100 }}>
  <div class="pomWrap">
    <div class="timerWrap">
      <img
        on:click={startPomodoro}
        class="timer"
        src="./images/timer.svg"
        alt="start timer" />
      <p class="start">Start</p>
    </div>
    <progress
      on:start={startPomodoro}
      on:click={handlePause}
      value={pomodoroTime / maxTime} />

    <div class="barFooter">
      <p bind:this={updates} class="name">{name}</p>
      <p>Click bar to pause.</p>
      <time bind:this={updates}>{formatTime(pomodoroTime)}</time>
    </div>
  </div>
  <footer>
    <p>Time: &nbsp;</p>
    <input
      bind:value={custom}
      on:change={() => setPomodoro(custom)}
      id="custom"
      type="number" />
    <button on:click={() => setPomodoro('work')}>
      <span class="gradient-text">Work</span>
    </button>
    <button on:click={() => setPomodoro('long')}>
      <span class="gradient-text">Long Work</span>
    </button>
    <button on:click={() => setPomodoro('break')}>
      <span class="gradient-text">Break</span>
    </button>
    <button on:click={cancelPomodoro}>
      <span class="gradient-text">Cancel</span>
    </button>
  </footer>
</section>
